export const PRODUCT_GET_REQUEST = "PRODUCT_GET_REQUEST";
export const PRODUCT_GET_SUCCESS = "PRODUCT_GET_SUCCESS";
export const PRODUCT_GET_FAIL = "PRODUCT_GET_FAIL";
export const PRODUCT_CREATE_REQUEST = "PRODUCT_CREATE_REQUEST";
export const PRODUCT_CREATE_SUCCESS = "PRODUCT_CREATE_SUCCESS";
export const PRODUCT_CREATE_FAIL = "PRODUCT_CREATE_FAIL";
export const PRODUCT_DELETE_REQUEST = "PRODUCT_DELETE_REQUEST";
export const PRODUCT_DELETE_SUCCESS = "PRODUCT_DELETE_SUCCESS";
export const PRODUCT_DELETE_FAIL = "PRODUCT_DELETE_FAIL";
export const SET_SELECTED_PRODUCT = "SET_SELECTED_PRODUCT";
export const PRODUCT_EDIT_REQUEST = "PRODUCT_EDIT_REQUEST";
export const PRODUCT_EDIT_SUCCESS = "PRODUCT_EDIT_SUCCESS";
export const PRODUCT_EDIT_FAIL = "PRODUCT_EDIT_FAIL";
export const SET_FILTERED_LIST = "SET_FILTERED_LIST";
export const CATEGORY = ["Top", "Dress", "Pants", "Home", "Other", "Women", "Divided", "Men", "Baby", "Kids", "Home", "Sale", "Sustainability"];
export const STATUS = ["active", "disactive"];
export const SIZE = ["XS", "S", "M", "L", "XL", "FREE", "Queen(90 x 90 inches)", "King(104 x 90 inches)"];
export const TOGGLE_ITEM_DIALOG = "TOGGLE_ITEM_DIALOG";
export const SEARCH_PRODUCT_REQUEST = " SEARCH_PRODUCT_REQUEST";
export const SEARCH_PRODUCT_SUCCESS = " SEARCH_PRODUCT_SUCCESS";
export const SEARCH_PRODUCT_FAIL = " SEARCH_PRODUCT_FAIL";
export const GET_PRODUCT_DETAIL_REQUEST = "GET_PRODUCT_DETAIL_REQUEST";
export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS";
export const GET_PRODUCT_DETAIL_FAIL = "GET_PRODUCT_DETAIL_FAIL";
export const SET_SEARCH_KEYWORD = "SET_SEARCH_KEYWORD";
